<template>
  <div class="login">
    <div class="loginWrap">
      <div class="logo"></div>
      <div class="loginDiv">
        <div class="loginTitle"></div>
        <el-input class="input" v-model="username" placeholder="账号"></el-input>
        <el-input class="input" type="password" v-model="password" placeholder="密码"></el-input>
        <el-input class="codeInput" v-model="code" placeholder="验证码"></el-input>
        <img class="codeImage" :src="codeUrl" width="72px" height="32" @click="changeImg">
        <el-button class="loginBtn" type="primary" size="medium" :loading="loginLoading" @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '', // 账号
      password: '', // 密码
      code: '', // 验证码
      codeUrl: '', // 验证码地址
      loginLoading: false // 登录按钮状态
    }
  },
  mounted () {
    // 获取验证码图片
    this.getCodeImg()

    document.onkeyup = () => {
      const e = event || window.event
      // 回车键的键值为13
      if (e && e.keyCode === 13) {
        this.login()
      }
    }
  },
  methods: {
    getCodeImg () {
      this.$http({
        method: 'get',
        url: this.$api.code_image,
        responseType: 'arraybuffer'
      }).then((res) => {
        this.codeUrl = 'data:image/png;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
      }).catch((err) => {
        console.log(err)
      })
    },
    changeImg () {
      this.getCodeImg()
    },
    login () {
      if (this.username === '' || this.password === '') {
        this.$message({
          type: 'error',
          message: '用户名、密码不能为空',
          duration: 1000
        })
      } else {
        this.loginLoading = true

        let formData = new FormData()
        formData.append('account', this.username)
        formData.append('password', this.password)
        formData.append('code', this.code)
        this.$http({
          method: 'post',
          url: this.$api.user_login,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            sessionStorage.setItem('token', data.data.token)
            this.$message({
              message: '登录成功',
              type: 'success',
              duration: 1000
            })
            this.$store.dispatch('userLogin', data.data.menus)
            this.$store.dispatch('userDetail', {
              userId: data.data.id,
              userName: data.data.name,
              villageId: this.getNotData(data.data.orgDepartment.id),
              villageName: this.getNotData(data.data.orgDepartment.orgName),
              villageAddress: this.getNotData(data.data.orgDepartment.address),
              username: this.username,
              password: this.password,
              dlevelcode: this.getNotData(data.data.orgDepartment.orgCode)
            })
            let menu1 = this.$store.state.menus.menu1
            let menu2 = this.$store.state.menus.menu2
            let menuAll = []
            for (let i = 0; i < menu1.length; i++) {
              if (menu1[i].url !== '/') {
                menuAll.push(menu1[i])
              } else {
                for (let j = 0; j < menu2.length; j++) {
                  if (menu1[i].id === menu2[j].pId) {
                    if (menu2[j].url !== '/') {
                      menuAll.push(menu2[j])
                    }
                  }
                }
              }
            }
            for (let i = 0; i < menuAll.length; i++) {
              if (menuAll[i].url !== '/') {
                setTimeout(() => {
                  this.$router.push(menuAll[i].url)
                  this.$store.dispatch('activeMenu', menuAll[i].url)
                }, 1000)
                break
              }
            }
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
            this.loginLoading = false
          }
          this.getCodeImg()
        }).catch((err) => {
          this.loginLoading = false
          this.getCodeImg()
          console.log(err)
        })
      }
    },
    getNotData (str) {
      if (str === null) {
        return ''
      } else {
        return str
      }
    }
  },
  beforeDestroy () {
    document.onkeyup = () => {
      return false
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.login
  box-sizing border-box
  position relative
  width 100%
  height 100%
  background-image url('./login_bg.jpg')
  background-repeat no-repeat
  background-size cover
  .loginWrap
    position absolute
    top 50%
    right 15%
    margin-top -270px
    width 380px
    height 540px
    .logo
      margin 0 auto
      width 320px
      height 80px
      background-image url('./login_logo.png')
      background-repeat no-repeat
      background-size 100% 100%
    .loginDiv
      box-sizing border-box
      margin-top 56px
      padding-top 48px
      width 380px
      height 396px
      background-image url('./login_input_bg.png')
      background-repeat no-repeat
      background-size 100% 100%
      .loginTitle
        margin 0 auto 48px
        width 240px
        height 34px
        background-image url('./login_title.png')
        background-repeat no-repeat
        background-size 100% 100%
      .input
        display block
        margin 0 auto 24px
        width 240px
        height 32px
        & >>> .el-input__inner
          height 32px
          line-height 32px
          border none
          border-radius 3px
      .codeInput
        display inline-block
        margin-left 70px
        margin-bottom 24px
        width 160px
        height 32px
        vertical-align top
        & >>> .el-input__inner
          height 32px
          line-height 32px
          border none
          border-radius 3px
      .codeImage
        display inline-block
        margin-left 4px
        margin-bottom 24px
        border-radius 4px
        vertical-align top
        cursor pointer
      .loginBtn
        display block
        margin 0 auto
        width 240px
        background-color #1B7FD6
        border-color #1B7FD6
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue